import { Component } from '@poa/core';
import React from 'react';
import Spinner from 'react-spinkit';
import moment from 'moment';
import { Observer } from '@poa/state';
import DownloadIcon from '../icons/download';
import { GRANTED_HOSTS } from '../../store/auth/auth.constants';


class ChatContent extends React.Component {

    store // injected by Poa
    actions // injected by Poa

    decodeHtmlContent = (text) => {
        const parser = new DOMParser();
        const decodedString = parser.parseFromString(
            `<!doctype html><body>${text}`, 'text/html'
        ).body.textContent;
        return decodedString.replace(/&lt;br \/&gt;/g, '<br />');
    }

    handleDownloadChat = () => {
        const chat_list = this.store.chats.chat_list;
        const chat_data = chat_list.map((item) => {
            return `[${item.date} ${moment.unix(item.timestamp).format('MMMM Do YYYY, h:mm:ss a')}] \n${item.sender} :\n${this.decodeHtmlContent(item.text)}`;
        }).join('\n\n\n =============================================================== \n\n\n');
        const dataStr = "data:text/plain;charset=utf-8," + encodeURIComponent(chat_data);
        const downloadAnchorNode = document.createElement('a');
        downloadAnchorNode.setAttribute("href", dataStr);
        downloadAnchorNode.setAttribute("download", `chat_${this.store.chats.selectedAccountId}_${this.store.chats.selectedUserId}.txt`);
        document.body.appendChild(downloadAnchorNode); // required for firefox
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
    }

    handleDownloadChatJson = () => {
        const chat_list = this.store.chats.chat_list;

        const processedChatList = chat_list.map(item => ({
            ...item,
            sender_id: item.sender === 'Me' ? `${this.store.chats.selectedAccountId}` : `${this.store.chats.selectedUserId}`,
            author_name: item.sender,
            date: new Date(item.timestamp * 1000).toISOString(),
            message: item.text,
        }));
        const chat_data = JSON.stringify(processedChatList, null, 2);

        const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(chat_data);
        const downloadAnchorNode = document.createElement('a');
        downloadAnchorNode.setAttribute("href", dataStr);
        downloadAnchorNode.setAttribute("download", `chat_${this.store.chats.selectedAccountId}_${this.store.chats.selectedUserId}.json`);
        document.body.appendChild(downloadAnchorNode); // required for firefox
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
    }

    handleSaveChatJson = () => {
        const chat_list = this.store.chats.chat_list;

        const processedChatList = chat_list.map(item => ({
            ...item,
            sender_id: item.sender === 'Me' ? `${this.store.chats.selectedAccountId}` : `${this.store.chats.selectedUserId}`,
            author_name: item.sender,
            date: new Date(item.timestamp * 1000).toISOString(),
            message: item.text,
        }));
        const chat_data = JSON.stringify(processedChatList, null, 2);

        this.actions.chatsActions.saveChatJson(
            chat_data
        ).then(() => {
            console.log('Chat saved successfully');
        }).catch((error) => {
            console.error('Error saving chat:', error);
        });
    }

    render() {
        return (

            <Observer>
                {() => (
                    <div className='chat_content'>
                        {
                            this.store.chats.chat_list.length !== 0  &&  
                            <>              
                            <button className='download_btn' onClick={this.handleDownloadChat}>
                                <DownloadIcon /> Download chat
                            </button>              
                            <button className='download_btn' style={{
                                marginLeft: '10px',
                                backgroundColor: '#4CAF50',
                                color: 'blue',
                                top: '6em'
                            }} onClick={this.handleDownloadChatJson}>
                                <DownloadIcon /> Download JSON
                            </button>
                            {this.store.auth.currentHost !== GRANTED_HOSTS.dm &&
                                (<button className='download_btn' style={{
                                marginLeft: '10px',
                                backgroundColor: 'lightblue',
                                color: '#000',
                                top: '10em'
                            }} onClick={this.handleSaveChatJson}>
                                <DownloadIcon /> Save to DB
                            </button>)
                            }
                            </>         
                        }

                        <div className='msg_list'>
                            {this.store.chats.chat_meta.isLoading ? (
                                <div className="spinner-loading" style={{ paddingTop: '75px', textAlign: 'center' }}>
                                    <Spinner name="folding-cube" fadeIn="none" />
                                </div>
                            ) :
                                this.store.chats.chat_meta.hasError ? (
                                    <div className="spinner-loading" style={{ paddingTop: '75px', textAlign: 'center' }}>
                                        <h1>Error occurred</h1>
                                    </div>
                                ) :
                                    this.store.chats.chat_list.map((item) => (
                                        <div className={`msg_item ${item.sender === "Me" ? 'acc_msg' : 'user_msg'}`}>
                                            <div className={`msg_header ${item.sender === "Me" ? 'acc_header' : 'user_header'}`}>
                                                <div className='name'>
                                                    {item.sender}
                                                </div>
                                                <div className='date'>
                                                    {`${item.date} ${moment.unix(item.timestamp).format('MMMM Do YYYY, h:mm:ss a')}`}
                                                </div>
                                            </div>
                                            <div 
                                            className='msg_body' 
                                            dangerouslySetInnerHTML={{
                                                    __html: this.decodeHtmlContent(item.text)
                                                }}>
                                            </div>
                                        </div>
                                    ))}
                        </div>
                    </div>

                )}
            </Observer>

        );
    };
}

export default Component({ namespaces: ['chats-content'] })(ChatContent);